module.exports = __webpack_public_path__ + "static/img/2.6e1beca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.jpg
// module id = Mn6R
// module chunks = 1